import {getDateFromIsoString} from '@shared/api';
import {UserReport} from '../types';
import {UserReportOnBackend} from './backendTypes';

export const mapUserReportFromBackend = ({
  id,
  reporter_id,
  reporter_username,
  reported_user_id,
  reported_username,
  cause,
  processed,
  created_at,
}: UserReportOnBackend): UserReport => ({
  id,
  reporterId: reporter_id,
  reporterUsername: reporter_username,
  reportedUserId: reported_user_id,
  reportedUsername: reported_username,
  cause: cause ?? null,
  processed,
  createdAt: getDateFromIsoString(created_at),
});
